import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';
import { useGitHubStats } from '../../hooks/useGitHubStats';
import './Graph.css';

const CHART_COLORS = [
  '#10b981', '#34d399', '#6ee7b7',
  '#3b82f6', '#8b5cf6', '#f59e0b',
  '#ef4444', '#ec4899', '#14b8a6',
];

const Graph = () => {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);
  const { languages, loading } = useGitHubStats('Windowmac');

  useEffect(() => {
    if (loading || !canvasRef.current || Object.keys(languages).length === 0) return;

    if (chartRef.current) chartRef.current.destroy();

    const sorted = Object.entries(languages)
      .sort(([, a], [, b]) => b - a)
      .slice(0, 8);

    chartRef.current = new Chart(canvasRef.current, {
      type: 'doughnut',
      data: {
        labels: sorted.map(([lang]) => lang),
        datasets: [{
          data: sorted.map(([, bytes]) => bytes),
          backgroundColor: CHART_COLORS.slice(0, sorted.length),
          borderColor: '#0c1424',
          borderWidth: 3,
          hoverOffset: 8,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        cutout: '62%',
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              color: '#94a3b8',
              font: { family: 'Inter', size: 12, weight: '500' },
              padding: 14,
              boxWidth: 12,
              boxHeight: 12,
              borderRadius: 4,
              useBorderRadius: true,
            },
          },
          tooltip: {
            backgroundColor: '#0f1929',
            borderColor: '#1a2640',
            borderWidth: 1,
            titleColor: '#f1f5f9',
            bodyColor: '#94a3b8',
            padding: 12,
            callbacks: {
              label: (ctx) => {
                const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
                const pct = ((ctx.parsed / total) * 100).toFixed(1);
                return ` ${ctx.label}: ${pct}%`;
              },
            },
          },
        },
      },
    });

    return () => { if (chartRef.current) chartRef.current.destroy(); };
  }, [languages, loading]);

  return (
    <div className="graph">
      <h3 className="graph__title">GitHub Languages</h3>
      {loading ? (
        <div className="graph__loading" aria-live="polite">Loading stats…</div>
      ) : (
        <canvas ref={canvasRef} aria-label="GitHub language usage chart" role="img" />
      )}
    </div>
  );
};

export default Graph;
